var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse436(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 436",
    d: "M60.5 120C27.3629 120 0.5 93.1371 0.5 60C0.5 26.8629 27.3629 0 60.5 0C93.6371 0 120.5 26.8629 120.5 60C120.5 93.1371 93.6371 120 60.5 120ZM60.5 15C35.6472 15 15.5 35.1472 15.5 60C15.5 84.8528 35.6472 105 60.5 105C85.3528 105 105.5 84.8528 105.5 60C105.5 35.1472 85.3528 15 60.5 15Z",
    fill: "#1BA421"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse436);
export default __webpack_public_path__ + "static/media/Ellipse436.3374ca18f97bab38604a224e7d3e1c0f.svg";
export { ForwardRef as ReactComponent };